// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bb2f6fe","455":"0722391e","488":"a835795a","867":"88f02f93","977":"f48becad"}[chunkId] + ".chunk.js";
};